/* eslint-disable no-unused-vars */
const zh = {
  topTitle: 'For somoother charging, use the app!'
}
export default zh
